import Equifax from "../../assets/company-logos/Equifax.png";
import DataAxle from "../../assets/company-logos/dataaxle.png";
import Experian from "../../assets/company-logos/Experian.png";
import Pipl from "../../assets/company-logos/pipl.svg";
import L2 from "../../assets/company-logos/L2.png";
import Acxiom from "../../assets/company-logos/Acxiom.png";
import Infutor from "../../assets/company-logos/Infutor.png";
import TeleSign from "../../assets/company-logos/TeleSign.png";
import Ekata from "../../assets/company-logos/Ekata.png";

const data = {
  usecaseInfo: {
    name: "Optimize Lead Outreach",
    description:
      "A single platform to enrich new and existing leads (person, place, business) with contact details globally.",
  },
  recipesInfo: {
    title: "Maximize Lead Contactability",
    description:
      "Access API-ready solutions to enrich leads with contact details including phone, email, most recent address, and employer, among many others.",
  },
  recipes: [
    {
      type: "People Data",
      title: "Email Identity Validation",
      description:
        "Validate an individual's email address based on its age, domain, risk-level across online activities, and mapping to the applicant.",
    },
    {
      type: "People Data",
      title: "Phone Validation",
      description:
        "Validate an individual's phone number based on its connection status, carrier, risk-level, and mapping to the applicant.",
    },
    {
      type: "People Data",
      title: "Reverse Phone Lookup",
      description:
        "Find missing/unfilled outputs like names, addresses, and emails where a phone number exists.",
    },
    {
      type: "People Data",
      title: "US Person Address From Name and Phone",
      description:
        "Use other forms of PI in order to find someone's address to help with address decay when moving.",
    },
    {
      type: "Other Data",
      title: "...And Many More",
      description: "Access 100's of api-ready recipes.",
      ctaText: "Access Recipe Catalog",
    },
  ],
  dataPartners: {
    title: "Sample Data Providers",
    description: "Access to hundreds of data partners worldwide",
    logos: [
      {
        name: "People Data Labs",
        img: DataAxle,
      },
      {
        name: "Pipl",
        img: Pipl,
      },
      {
        name: "TeleSign",
        img: TeleSign,
      },
      {
        name: "Acxiom",
        img: Acxiom,
      },
      {
        name: "L2",
        img: L2,
      },
      {
        name: "Infutor",
        img: Infutor,
      },
      {
        name: "DataAxle",
        img: DataAxle,
      },
      {
        name: "Experian",
        img: Experian,
      },
      {
        name: "Equifax",
        img: Equifax,
      },
      {
        name: "Ekata",
        img: Ekata,
      },
    ],
  },
  resourcesInfo: {
    title: "Resources",
    description: "The latest news, technologies, and resources from our team.",
  },
  resources: [
    {
      title: "Addressing Data Decay in Phone Numbers",
      url: "https://demyst.com/blog/what-happens-to-a-business-when-phone-numbers-are-inaccurate",
      featured_image: "https://cdn.buttercms.com/H4dlSKqhScyxR0M65gY6",
      date: "2021-10-09",
      description:
        "Phone numbers are a crucial component of marketing, customer relations, and account management. Indeed, apart from outbound email campaigns and Linkedin outreach, many organizations depend on phone calls for cold outreach campaigns. But in the B2B space, these records are continually changing, which can cause problems for the marketing campaigns that rely on them.",
      more: "",
    },
  ],
};

export default data;
